import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-groups-multiselect-dropdown',
  templateUrl: './groups-multiselect-dropdown.component.html',
  styleUrl: './groups-multiselect-dropdown.component.scss'
})
export class GroupsMultiselectDropdownComponent {

  @Input() selectedValues: any = []
  @Input() dataSource: any[] = []
  @Input() label:string = ""
  @Output() addToList: EventEmitter<any> = new EventEmitter();

  timeOut:any=0

  constructor() { }

  ngOnInit(): void {
  }

  /*----------------------Functions Called from parent---------------------- */
  // setValue(data){
  //   // console.log("eventdata",data)
  //   this.userVal = `[${data.Service_Id}] - ${data.Service_Id}`;
  // }

  reset(){
    this.selectedValues = []
    this.addToList.emit([])
  }

  /*----------------------when Choosing User---------------------- */
  selectItem($event: any) {
    this.selectedValues = $event
    let itemsIds = this.selectedValues.map((i:any)=>i._id)
    this.addToList.emit(itemsIds)
  }
}
